import React, {Component}  from 'react';
import _                   from 'lodash';
import AppActions          from './../../actions/AppActions';

class BoundTextArea extends Component {
    render() {
        const props = this.props;
        const path = props.path;
        const format = props.format;
        const value = format === 'array'
            ? props.value.join('\r\n')
            : props.value;

        const handleChange = (event) => {
            const element = event.target;
            const getValue = props.getValue || ((val) => val);
            const newValue = getValue(element.value);

            AppActions.updateState(path, newValue);
        };

        return <textarea
            onChange={handleChange}
            {...this.props}
            value={value}
        ></textarea>;
    }
}

export default BoundTextArea;